import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConverterService, LanguageService, OccEndpointsService, PRODUCT_NORMALIZER, RoutingService } from '@spartacus/core';
import { BehaviorSubject, combineLatest, Observable, Subject, using } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map, mergeMap, shareReplay, switchMap, tap } from 'rxjs/operators';
import { KB_CATEGORY_NORMALIZER, KB_PRODUCT_URL_NORMALIZER } from '../app.module';
import { KbProductUrlNormalizer } from '../services/pageNormalizer/kb-product-url.normalizer';

@Injectable({
  providedIn: 'root',
})
export class CategoryPageService {


  categoryData = new BehaviorSubject<any>(null);
  categoryData$ = this.categoryData.asObservable();

  constructor(
    private http: HttpClient,
    private occService: OccEndpointsService,
    private activatedRoute: RoutingService,
    private languageService: LanguageService,
    private converterService:ConverterService
  ) {}
  model$: Observable<any> = using(
    () => this.searchByRouting$.subscribe(),
    () => this.categoryData$
  ).pipe(shareReplay({ bufferSize: 1, refCount: true }));
  searchByRouting$ = combineLatest([
    this.activatedRoute.getRouterState().pipe(
      distinctUntilChanged((x, y) => {
        // router emits new value also when the anticipated `nextState` changes
        // but we want to perform search only when current url changes
        return x.state.url === y.state.url;
      })
    ),
    this.languageService.getActive(),
  ]).pipe(
    distinctUntilChanged(),
    debounceTime(0),
    map(([state, _lang]) => {
      return state.state.params?.['categoryCode'];
    }),
     filter(categoryCode => !!categoryCode),
    tap((categoryCode) => {
      this.getCategoryPageData(categoryCode, '', 0, 12).subscribe();
    })
  );
  getCategoryPageData(categoryCode, query?, currentPage?, pageSize?, sort?) {
    return this.http
      .get<any>(
        this.occService.buildUrl('/products/search', {
          queryParams: {
            categoryCode,
            query,
            currentPage,
            pageSize,
            sort,
          },
        })
      )
      .pipe(
        tap((res) => {
          if (res?.subCategories?.length > 1) {
            res.subCategories = res?.subCategories?.sort((category, comparWithCategoty) =>
              category?.name?.localeCompare(comparWithCategoty?.name)
            );
            res.subCategories= res?.subCategories?.map((category)=>{              
              return this.converterService.convert(category,KB_CATEGORY_NORMALIZER)
            })
            
          }
          if (res?.products) {           
            res.products= res.products.map((products)=>{
              return this.converterService.convert(products,PRODUCT_NORMALIZER)
            }).map((x)=>{
              return this.converterService.convert(x,KB_PRODUCT_URL_NORMALIZER)
            })
          }
          
          this.categoryData.next(res);
        })
      );
  }

}
